module.exports = __webpack_public_path__ + "static/9-aldous-614e463264ae6f1e41d3144078948af1.jpg";